import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Table } from "reactstrap";
// import { Table, Input, Menu, DatePicker } from 'antd';
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import {
  getSchedules,
  deleteSchedule,
  updateSchedule,
} from "../../../redux/actions/schedules";
import { getWorkers } from "../../../redux/actions/workers";
import { getProcesses } from "../../../redux/actions/processes";
import EmptyScreen from "./images/Empty-Screen.png";
import CustomModal from "../../../UtilityComponents/customModal";
import CreateSchedule from "./create";
import DeleteSchedule from "./delete";
import { addNotification } from "../../../Utilities/notifications";
import stringToDate from "../../../Utilities/stringToDate";
import loader from "./images/loaderTransaparent.gif";
import ScheduleSuccess from "./success";
import { notify } from "../../../redux/actions/snack";
import "./index.css";
import { getAllApiTokens } from "../../../redux/actions/auth";
import { useDispatch, useSelector } from "react-redux";
import editIcon from "../../../../src/images/edit-icon.png";
import cronstrue from "cronstrue";
import * as XLSX from "xlsx";
import { publishFlow } from "../../../redux/actions/skill";
import { getSession } from "../../../redux/actions/skill";

import {
  MoreOutlined,
  InfoCircleOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { Dropdown, Popover, Tooltip, Modal } from "antd";

function Schedules(props) {
  let { user } = props;
  const [loading, setLoading] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [workers, setWorkers] = useState(false);
  const [bots, setBots] = useState(false);
  const [schedules, setSchedules] = useState([]);
  const [modal, setModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [schedule, setSchedule] = useState({});
  const [search_data, setsearch_data] = useState();
  const [schedule_Success, setScheduleSuccess] = useState(false);
  const [createSchedule, setCreateSchedule] = useState(false);
  const [newName, setNewName] = useState("");
  const [newStopTime, setNewStopTime] = useState("");
  const [isLoading, setIsLoading] = useState(false)
   let [err, setErr] = useState(false);
    let [minErr, setMinErr] = useState(false);
    let [cronErr, setCronErr] = useState(false);
    let [validate, setValidate] = useState(false);
    let [workerName, setWorkerName] = useState("");
    const [selectedWeekDays, setSelectedWeekDays] = useState("");
    const [selectedWeekDaysForMonths, setSelectedWeekDaysForMonths] = useState("");
    const [selectedMonths, setSelectedMonths] = useState('');
     const [enableSubmit, setEnableSubmit] = useState(true);
    const sessionData = useSelector((state) => state.skillReducer.devices);
  const dispatch = useDispatch();

  useEffect(() => {
    // document.title = "Schedules | SuperApp | Techforce.ai";
    const fetchData = async () => {
      setLoading(true);
      let data = await getSchedules();
      setLoading(false);
      if (data && data.length > 0) {
        setSchedules(data);
      }
      dispatch(getAllApiTokens());
    };
    fetchData();
  }, []);

  useEffect(() => {
    dispatch(getSession());
  }, []);



  let state = {
    name: "",
    workerType: "standard",
    worker: "0",
    bot_id: "Select",
    timeZone: "0",
    excecutionType: "0",
    triggerType: "minutes",
    hours: "",
    minutes: "",
    advanced_expression: "",
    stop_time: "",
    stop_date: "",
    stop: false,
    stop_type: "stop",
    params: false,
    parameters: "",
    paramsType: "String",
  };
   const [months, setMonths] = useState([
      { id: 1, value: "Jan", active: false },
      { id: 2, value: "Feb", active: false },
      { id: 3, value: "Mar", active: false },
      { id: 4, value: "Apr", active: false },
      { id: 5, value: "May", active: false },
      { id: 6, value: "Jun", active: false },
      { id: 7, value: "Jul", active: false },
      { id: 8, value: "Aug", active: false },
      { id: 9, value: "Sep", active: false },
      { id: 10, value: "Oct", active: false },
      { id: 11, value: "Nov", active: false },
      { id: 12, value: "Dec", active: false },
    ]);
  
    const [weekDays, setWeekDays] = useState([
      { id: "1", value: "Mon", name: "days", active: false },
      { id: "2", value: "Tue", name: "days", active: false },
      { id: "3", name: "days", value: "Wed", active: false },
      { id: "4", name: "days", value: "Thu", active: false },
      { id: "5", value: "Fri", name: "days", active: false },
      { id: "6", value: "Sat", name: "days", active: false },
      { id: "0", value: "Sun", name: "days", active: false },
    ]);
    const [weekDaysForMonths, setWeekDaysForMonths] = useState([
      { id: "1", value: "Mon", name: "days", active: false },
      { id: "2", value: "Tue", name: "days", active: false },
      { id: "3", name: "days", value: "Wed", active: false },
      { id: "4", name: "days", value: "Thu", active: false },
      { id: "5", value: "Fri", name: "days", active: false },
      { id: "6", value: "Sat", name: "days", active: false },
      { id: "0", value: "Sun", name: "days", active: false },
    ]);
 
    const [obj, setObj] = useState({
      triggerType: "minutes", 
      hours: "", 
      minutes: "",
      months: [], 
      weeksForMonths: [], 
      weeks: [],
      months: [],
      params: false, 
    });
  const scheduleSuccess = () => {
    toggle();
    scheduleSuccessPage();
  };

  const scheduleSuccessPage = () => {
    setScheduleSuccess(!schedule_Success);
  };

  const reload = async () => {
    scheduleSuccessPage();
    let data = await getSchedules();
    if (data.length > 0) {
      setSchedules(data);
    }
  };

  const handleChange = (e) => {
    setsearch_data(e.target.value);
    if (e.target.value.length === 0) {
      setsearch_data(null);
      fetchData();
    }
  };

useEffect(() => {
  const activeWeekDays = weekDays.filter((day) => day.active).map((day) => (day.id === 0 ? 7 : day.id));
  setSelectedWeekDays(activeWeekDays);

  const activeWeekDaysForMonths = weekDaysForMonths.filter((day) => day.active).map((day) => (day.id === 0 ? 7 : day.id));
  setSelectedWeekDaysForMonths(activeWeekDaysForMonths);

  const activeMonths = months.filter((month) => month.active).map((month) => month.id);
  setSelectedMonths(activeMonths);

  let cronExpression = [`*/${obj.minutes}`, "*", "*", "*", "*"];

  switch (obj.triggerType) {
    case "minutes":
      cronExpression = [`*/${obj.minutes}`, "*", "*", "*", "*"];
      break;
    case "hourly":
      cronExpression = [`${obj.minutes}`, `*/${obj.hours}`, "*", "*", "*"];
      break;
    case "daily":
      cronExpression = [`${obj.minutes}`, `${obj.hours}`, "*", "*", "*"];
      break;
    case "weekly":
      let days = activeWeekDays.join(',');
      cronExpression = [`${obj.minutes}`, `${obj.hours}`, "*", "*", days];
      break;
    case "monthly":
      let selectedDays = activeWeekDaysForMonths.join(',');
      let selectedMonths = activeMonths.map(month => month ).join(',');
      cronExpression = [`${obj.minutes}`, `${obj.hours}`, "*", selectedMonths, selectedDays];
      break;
    case "advanced":
      if (obj.advanced_expression) {
        cronExpression = obj.advanced_expression.split(" ");
      } else {
        cronExpression = ["*", "*", "*", "*", "*"];
      }
      break;
    default:
      cronExpression = ["*", "*", "*", "*", "*"];
      break;
  }

  const updatedValues = {
    hours: obj.hours || "",
    minutes: obj.minutes || "",
    weeks: obj.weeks || "",
    weeksForMonths: activeWeekDaysForMonths,
    months: obj.months || "",
  };

  setObj((prevState) => ({
    ...prevState,
    cron_expression: cronExpression.join(" "),
    ...updatedValues,
  }));
}, [weekDays, weekDaysForMonths, obj.triggerType, months, obj.advanced_expression]);


const handleTriggerChange = (e) => {
  e.preventDefault();
  setErr(false);

  let updatedObj = { ...obj };

  if (e.target.name === "months") {
    const monthId = parseInt(e.target.value, 10);
    
    let updatedMonths = months.map((mon) => {
      if (mon.id === monthId) {
        return { ...mon, active: !mon.active };
      }
      return mon;
    });
    setMonths(updatedMonths);

    let activeMonths = updatedMonths.filter((mon) => mon.active).map((mon) => mon.id);
    setSelectedMonths(activeMonths);
  } else if (e.target.name === "weeksForMonths" || e.target.name === "weeks") {
    const isWeeksForMonths = e.target.name === "weeksForMonths";
    const updatedDays = isWeeksForMonths
      ? weekDaysForMonths.map((day) => (day.id === e.target.value ? { ...day, active: !day.active } : day))
      : weekDays.map((day) => (day.id === e.target.value ? { ...day, active: !day.active } : day));

    if (isWeeksForMonths) {
      setWeekDaysForMonths(updatedDays);
      setSelectedWeekDaysForMonths(updatedDays);
    } else {
      setWeekDays(updatedDays);
      setSelectedWeekDays(updatedDays);
    }
  } else if (e.target.type === "radio") {
    const workerType = e.target.name;
    const filteredWorkers = props.workers ? props.workers.filter((worker) => worker.worker_type === workerType) : [];
    setWorkers(workerType === "dynamic" && filteredWorkers.length > 0 ? [filteredWorkers[0]] : filteredWorkers);
    updatedObj = { ...updatedObj, workerType };
    setObj(updatedObj);
  } else if (["hours", "minutes"].includes(e.target.name)) {
    const value = e.target.value;
    updatedObj = { ...updatedObj, [e.target.name]: value };

    if (e.target.name === "hours") {
      if (value > 24 || value <= 0) {
        setValidate("Please select up to 24 hours & not 0");
      } else {
        setValidate(false);
      }
    } else if (e.target.name === "minutes") {
      const value = e.target.value;
      updatedObj = { ...updatedObj, [e.target.name]: value };
    
      if ((updatedObj?.hours?.length < 1 || parseInt(updatedObj?.hours) < 1) && value < 15) {
        setMinErr("Schedules with frequency below 15 minutes are not allowed. Please reach out to our support to enable schedules with frequency below 15 minutes.");
      } else {
        setMinErr(value > 60 ? "Please select valid minutes" : false);
      }
    }
  } else if (e.target.name === "advanced_expression") {
    let cronMinValue = e.target.value?.split(" ")[0];

    if (cronMinValue?.includes("*/")) {
      cronMinValue = cronMinValue?.replace(/[^0-9]/g, '');
      if (cronMinValue < 15) {
        cronErr = "Schedules with frequency below 15 minutes are not allowed.";
        setCronErr(cronErr);
        props.notify("error", cronErr);
      } else {
        updatedObj = { ...updatedObj, advanced_expression: e.target.value };
      }
    } else {
      updatedObj = { ...updatedObj, advanced_expression: e.target.value };
    }
  }

  setObj(updatedObj);

  setObj((prevState) => {
    const updatedState = { ...prevState, [e.target.name]: e.target.value };

    const activeWeekDays = weekDays.filter((day) => day.active).map((day) => (day.id === 0 ? 7 : day.id));
    setSelectedWeekDays(activeWeekDays);
    const activeWeekDaysForMonths = weekDaysForMonths.filter((day) => day.active).map((day) => (day.id === 0 ? 7 : day.id));
    setSelectedWeekDaysForMonths(activeWeekDaysForMonths);

    const activeMonths = months.filter((month) => month.active).map((month) => month.id); // <-- Define activeMonths here
    setSelectedMonths(activeMonths);

    let cronExpression = [`*/${updatedState.minutes}`, "*", "*", "*", "*"];

    switch (updatedState.triggerType) {
      case "minutes":
        cronExpression = [`*/${updatedState.minutes}`, "*", "*", "*", "*"];
        break;
      case "hourly":
        cronExpression = [`${updatedState.minutes}`, `*/${updatedState.hours}`, "*", "*", "*"];
        break;
      case "daily":
        cronExpression = [`${updatedState.minutes}`, `${updatedState.hours}`, "*", "*", "*"];
        break;
      case "weekly":
        let days = '';
        activeWeekDays.forEach(day => {
          days += day + ',';
        });
        cronExpression = [`${updatedState.minutes}`, `${updatedState.hours}`, "*", "*", days.slice(0, -1)];
        break;
      case "monthly":
        let selectedDays = '';
        let selectedMonths = '';
        activeWeekDaysForMonths.forEach(day => {
          selectedDays += day + ',';
        });
        activeMonths.forEach(month => {
          selectedMonths += (month) + ',';
        });
        cronExpression = [`${updatedState.minutes}`, `${updatedState.hours}`, "*", selectedMonths.slice(0, -1), selectedDays.slice(0, -1)];
        break;
        case "advanced":
          if (updatedState.advanced_expression) {
            cronExpression = updatedState.advanced_expression.split(" ");
          } else {
            cronExpression = ["*", "*", "*", "*", "*"]; 
          }
          break;
      default:
        cronExpression = ["*", "*", "*", "*", "*"];
        break;
    }

    return { ...updatedState, cron_expression: cronExpression.join(" ") };
  });

  setEnableSubmit(false);
};


  const fetchData = async () => {
    setLoading(true);
    let data = await getSchedules();
    setLoading(false);
    if (data.length > 0) {
      setSchedules(data);
    }
  };

  const handleSearch = async () => {
    if (search_data) {
      let org = schedules.find((obj) => obj.name.toString() === search_data);
      if (org) {
        setSchedules([org]);
      } else {
        setSchedules([]);
      }
    } else {
      let data = await getSchedules();
      if (data.length > 0) {
        setSchedules(data);
      }
    }
  };

  const handleCreate = async () => {
    setProcessing(true);

    let workersData = await props.getWorkers();
    console.log("===>>>>>>>", workersData);

    setWorkers(workersData); 

    let botsData = await props.getProcesses();
    console.log(botsData, "bot=>>>>>>>>>>>>>>>>>>>>>>>");
    
    if (botsData.rows.length > 0) {
        setBots(botsData.rows);
        setModal(true);
    } else {
        props.notify(
          "error",
          "No action flows published. Please create an action flow and retry scheduling."
        );
        // addNotification({
        //   title: "Techforce.ai",
        //   message:
        //     "Seems like you haven't created any action flows, Please create a action flow and try to schedule",
        //   type: "info",
        //   container: "top-center",
        // });
        // setTimeout(() => {
        //   props.history.push("/processes");
        // }, 2000);
    }

    setProcessing(false);
};

  const handleCreateSchedule = async () => {
    setCreateSchedule(true);

    let workersData = await props.getWorkers();
    setWorkers(workersData);

    let botsData = await props.getProcesses();
    if (botsData.rows.length > 0) {
      setBots(botsData.rows);
      setModal(true);
    } else {
      props.notify(
        "error",
        "No action flows published. Please create an action flow and retry scheduling."
      );
    }

    setCreateSchedule(false);
  };

  const toggle = () => setModal(!modal);

  const deleteModalToggle = (obj) => {
    if (obj) {
      setSchedule(obj);
    }
    setDeleteModal(!deleteModal);
  };
  const handleDelete = async () => {
    deleteModalToggle();
    let cron_tasks = schedules.map((obj) => {
      if (obj.id === schedule.id) {
        return { ...obj, deleting: true };
      } else {
        return { ...obj };
      }
    });
    setSchedules(cron_tasks);

    try {
      await deleteSchedule(schedule.key);
      props.notify("success", "Schedule deleted succesfully.");
    } catch (err) {
      props.notify("error", "Schedule deletion failed.");
    }

    // setDelete(false);
    setLoading(true);

    let data = await getSchedules();

    setLoading(false);
    setSchedules(data);
  };

  const keyPress = async (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleEditClick = (obj) => {
  
    obj.cron_expression = obj.cron_expression.replace(/&#x2F;/g, "/");
    const [cronMinutes, cronHours] = obj.cron_expression?.split(" ") || ["*", "*"];

  setObj({
    ...obj,
    triggerType: obj.triggerType || "minutes",
    hours: cronHours === "*" ? "" : cronHours,
    minutes: cronMinutes.includes("*/") ? cronMinutes.split("/")[1] : "",
    months: obj.months || [],
    weeksForMonths: obj.weeksForMonths || [],
    weeks: obj.weeks || [],
    params: obj.params || false,
  });
    setEditingSchedule(obj.key);
    setNewName(obj.name);
    setNewStopTime(obj.stop_time);
    setSchedule(obj.key);
    setWorkerName(obj.worker_name);
    setEditModalOpen(true);
  };

  const handleSaveChanges = async () => {
    setIsLoading(true);
  
    try {
      await handleUpdate();
      setEditModalOpen(false); 
      props.notify("success", "Schedule updated successfully.");
    } catch (error) {
      props.notify("error", "Failed to update the schedule.");
    } finally {
      setIsLoading(false); 
    }
  };

  const handleUpdate = async () => {
    let cron_tasks = schedules.map((obj) =>
      obj.id === schedule.id ? { ...obj, deleting: true } : obj
    );

    const updatedCron = obj.cron_expression; 
  
    let cronParts = updatedCron.split(" ");
    if (cronParts.length === 6) {
      cronParts = cronParts.slice(0, 5); 
    }
    const validCron = cronParts.join(" "); 
    setSchedules(cron_tasks);
  
    try {
      await updateSchedule(schedule, newName, newStopTime, validCron, workerName);
    } catch (err) {
      throw err; 
    } finally {
      const data = await getSchedules();
      setSchedules(data);
    }
  };

  const getCronDescription = (cronExpression) => {
 
    cronExpression = cronExpression.replace(/&#x2F;/g, "/");
    try {
      return cronstrue.toString(cronExpression, { verbose: true });
    } catch {
      return "Invalid cron expression";
    }
  };

  const exportToExcel = (data) => {
    const formattedData = data.map((schedule) => ({
      Name: schedule.name,
      BotID: schedule.bot_id,
      WorkerName: schedule.worker_name || "-",
      TimeZone: schedule.timezone,
      Status: schedule.status,
      Email: schedule.email,
      CreatedAt: stringToDate(schedule.created_at),
      StopTime: stringToDate(schedule.stop_time),
      NextInterval: stringToDate(schedule.next_interval),
      TimeFrequency: getCronDescription(schedule.cron_expression),
      ExecutionType: schedule.execution_type,
      UpdatedAt: schedule.updated_at,
      UpdatedBy: schedule.updated_by,
      PublishedBy: schedule.published_by,
      Params: schedule.params? schedule.params : ""
    }));

    // Create a new workbook and add data
    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "SchedulesData");

    // Export the Excel file
    XLSX.writeFile(workbook, "SchedulesData.xlsx");
  };

  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editingSchedule, setEditingSchedule] = useState(null);

  const handleViewClick = (schedule) => {
    setSelectedSchedule(schedule); 
    setViewModalOpen(true);
  };

  const renderTrigger = () => {
    return (
      <div className="row">
        {obj.triggerType === "monthly" ? (
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-6">
                <div className="ip-tl-label">
                  <span className="tl-label" htmlFor="inputEmail4">
                    AT (HRS)
                  </span>
                  <input
                    type="number"
                    name="hours"
                    value={obj.hours}
                    onChange={handleTriggerChange}
                    min="1"
                    max="24"
                    placeholder="Enter"
                    required
                    style={{width: "100%"}}
                  ></input>
                </div>
                {validate !== false && (
                  <span className="error">{validate}</span>
                )}
              </div>
              <div className="col-md-6">
                <div className="ip-tl-label">
                  <span className="tl-label" htmlFor="inputEmail4">
                    Every(Min)
                  </span>
                  <input
                    type="number"
                    // className="form-control-1"
                    name="minutes"
                    value={obj.minutes}
                    onChange={handleTriggerChange}
                    min="1"
                    max="60"
                    placeholder="Enter"
                    required
                    style={{width: "100%"}}
                  ></input>
                </div>
                {minErr !== false && <span className="error">{minErr}</span>}
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <h5 className="sch-title">Every(Months)</h5>
                <div className="month-day-btns">
                  {months.map((month, index) => (
                    <button
                      key={index}
                      name="months"
                      value={month.id}
                      onClick={handleTriggerChange}
                      className={month.active ? "active" : ""}
                      style={{
                        backgroundColor: selectedMonths.includes(month.id)
                          ? "#007bff"
                          : "#f9f9f9",
                        color: selectedMonths.includes(month.id) ? "#fff" : "#000",
                        cursor: "pointer",
                      }}
                    >
                      {month.value}
                    </button>
                  ))}
                </div>
              </div>
              <div className="col-md-12">
                <h5 className="sch-title">Every(Days)</h5>
                <div className="month-day-btns">
                  {weekDaysForMonths?.map((day, index) => (
                    <button
                      key={index}
                      name="weeksForMonths"
                      value={day.id}
                      onClick={handleTriggerChange}
                      className={day.active ? "active" : ""}
                      style={{
                        backgroundColor: selectedWeekDaysForMonths.includes(day.id)
                          ? "#007bff"
                          : "#f9f9f9",
                        color: selectedWeekDaysForMonths.includes(day.id) ? "#fff" : "#000",
                        cursor: "pointer",
                      }}
                    >
                      {day.value}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ) : null}
        {obj.triggerType === "weekly" ? (
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-6">
                <div className="ip-tl-label">
                  <span className="tl-label" htmlFor="exampleInputName">
                    AT (HRS)
                  </span>
                  <input
                    type="number"
                    // className="form-control-1"
                    name="hours"
                    value={obj.hours}
                    onChange={handleTriggerChange}
                    min="1"
                    max="24"
                    placeholder="Enter"
                    required
                    style={{width: "100%"}}
                  ></input>
                </div>
                {validate !== false && (
                  <span className="error">{validate}</span>
                )}
              </div>
              <div className="col-md-6">
                <div className="ip-tl-label">
                  <span className="tl-label" htmlFor="exampleInputName">
                    EVERY (MIN)
                  </span>
                  <input
                    type="number"
                    // className="form-control-1"
                    name="minutes"
                    value={obj.minutes}
                    onChange={handleTriggerChange}
                    min="1"
                    max="60"
                    placeholder="Enter"
                    required
                    style={{width: "100%"}}
                  ></input>
                </div>
                {minErr !== false && <span className="error">{minErr}</span>}
              </div>
              <div className="col-md-12">
                <h5 htmlFor="exampleInputName">EVERY (DAYS)</h5>
                <div className="month-day-btns">
                  {weekDays?.map((day, index) => (
                    <button
                      key={index}
                      name="weeks"
                      value={day.id}
                      onClick={handleTriggerChange}
                      className={day.active ? "active" : ""}
                      style={{
                        backgroundColor: selectedWeekDays.includes(day.id)
                          ? "#007bff"
                          : "#f9f9f9",
                        color: selectedWeekDays.includes(day.id) ? "#fff" : "#000",
                        cursor: "pointer",
                      }}
                    >
                      {day.value}
                    </button>
                  ))}
                </div>
            
              </div>
            </div>
          </div>
        ) : null}

        {obj.triggerType === "daily" ? (
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-6">
                <div className="ip-tl-label">
                  <span className="tl-label" htmlFor="inputEmail4">
                    EVERY DAY AT (HRS)
                  </span>
                  <input
                    type="number"
                    name="hours"
                    value={obj.hours}
                    onChange={handleTriggerChange}
                    min="1"
                    max="24"
                    placeholder="Enter"
                    required
                    style={{width: "100%"}}
                  ></input>
                </div>
                {validate !== false && (
                  <span className="error">{validate}</span>
                )}
              </div>
              <div className="col-md-6">
                <div className="ip-tl-label">
                  <span className="tl-label" htmlFor="inputEmail4">
                    EVERY (MIN)
                  </span>
                  <input
                    type="number"
                    name="minutes"
                    value={obj.minutes}
                    onChange={handleTriggerChange}
                    min="1"
                    max="60"
                    placeholder="Enter"
                    required
                    style={{width: "100%"}}
                  ></input>
                </div>
                {minErr !== false && <span className="error">{minErr}</span>}
              </div>
            </div>
          </div>
        ) : null}

        {obj.triggerType === "hourly" ? (
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-6">
                <div className="ip-tl-label">
                  <span className="tl-label" htmlFor="inputEmail4">
                    EVERY (HRS)
                  </span>
                  <input
                    type="number"
                    // className="form-control-1"
                    name="hours"
                    value={obj.hours}
                    onChange={handleTriggerChange}
                    min="1"
                    max="24"
                    placeholder="Enter"
                    required
                    style={{width: "100%"}}
                  ></input>
                </div>
                {validate !== false && (
                  <span className="error">{validate}</span>
                )}
              </div>
              <div className="col-md-6">
                <div className="ip-tl-label">
                  <span className="tl-label" htmlFor="inputEmail4">
                    AT (MIN)
                  </span>
                  <input
                    type="number"
                    name="minutes"
                    value={obj.minutes}
                    onChange={handleTriggerChange}
                    min="1"
                    max="60"
                    placeholder="Enter"
                    required
                    style={{width: "100%"}}
                  ></input>
                </div>
                {minErr !== false && <span className="error">{minErr}</span>}
              </div>
            </div>
          </div>
        ) : null}

        {obj.triggerType === "minutes" ? (
          <div className="col-md-12">
            <div className="ip-tl-label">
              <span className="tl-label" htmlFor="exampleInputName">
                EVERY (MIN)
              </span>
              <input
                type="number"
                name="minutes"
                value={obj.minutes}
                onChange={handleTriggerChange}
                min="1"
                max="60"
                placeholder="Enter"
                required
                style={{width: "100%"}}
              ></input>
            </div>
            {minErr !== false && <span className="error">{minErr}</span>}
          </div>
        ) : null}

        {obj.triggerType === "advanced" ? (
          <div className="col-md-12">
            <div className="ip-tl-label">
              <label htmlFor="exampleInputName">CRON EXPRESSION</label>
              <input
                type="name"
                className="form-control-1"
                name="advanced_expression"
                onChange={handleTriggerChange}
                value={obj.advanced_expression}
                placeholder=" * * * * * "
                required
                style={{width: "100%"}}
              ></input>
            </div>
          </div>
        ) : null}
      </div>
    );
  };

  const mappedSchedules = schedules.map((obj) => {
    const workerName = sessionData.find((session) => session.id === obj.worker_id)?.session_name || "-";
    return { ...obj, worker_name: workerName };
  });
  

  if (loading) {
    return (
      <div className="task-col-search">
        <div className="row mx-0 setting-search bg-white py-3 border-left">
          <div className="col-md-8">
            <div className="position-relative search">
              <input
                id="searchField"
                type="search"
                placeholder="Search"
                className="form-control border-0"
              // value={this.state.searchItem ? this.state.searchItem : ""}
              // onChange={(e) => this.searchSkillStore(e)}
              // onKeyDown={(e) => this.onKeyPress(e)}
              />
              {/* <img src={SearchIcon} alt="Search" /> */}
            </div>
          </div>
        </div>

        <div className="task-col">
          <div className="title-btn">
            <h1 className="title">Schedules</h1>
            {/* <i className="fa fa-search" onClick={handleSearch} style={{height:"22px",color:"#938989",position:"absolute",right:"240px",padding:"7px",marginTop:"7px"}}></i>
          <input type="text"  name="search_data"onKeyPress={keyPress} onChange={handleChange}placeholder="Search" style={{height:"39px",backgroundColor:"#f7f7f7",position:"absolute",right:"95px"}}/> */}
            <button className="btn btn-primary" onClick={handleCreate}>
              {processing ? (
                <div className="sp sp-circle text-white"></div>
              ) : (
                "+ Create"
              )}
            </button>
          </div>
          <div id="scrollableDiv" className="scrollable tl-scroll">
            <div style={{ textAlign: "center", marginTop: "15%" }}>
              <img src={loader} width="120" alt="loading"></img>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="task-col-search">
        <div className="row mx-0 setting-search bg-white py-3 border-left">
          <div className="col-md-8">
            <div className="position-relative search">
              <input
                id="searchField"
                type="search"
                placeholder="Search"
                className="form-control border-0"
              // value={this.state.searchItem ? this.state.searchItem : ""}
              // onChange={(e) => this.searchSkillStore(e)}
              // onKeyDown={(e) => this.onKeyPress(e)}
              />
              {/* <img src={SearchIcon} alt="Search" /> */}
            </div>
          </div>
        </div>
        <div className="task-col">
          <div className="title-btn">
            <h1 className="title">Schedules</h1>
            {/* <i className="fa fa-search" onClick={handleSearch} style={{height:"22px",color:"#938989",position:"absolute",right:"240px",padding:"7px",marginTop:"7px"}}></i>
          <input type="text"  name="search_data"onKeyPress={keyPress} onChange={handleChange}placeholder="Search" style={{height:"39px",backgroundColor:"#f7f7f7",position:"absolute",right:"95px"}}/> */}
            <button className="btn btn-primary" onClick={handleCreate}>
              {processing ? (
                <div className="sp sp-circle text-white"></div>
              ) : (
                "+ Create"
              )}
            </button>
          </div>
          <div id="scrollableDiv" className="scrollable tl-scroll">
            {schedules.length > 0 ? (
              <div className="table-default">
                <Table className="table-main">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Bot Id</th>
                      <th style={{ whiteSpace: "nowrap" }}>Worker Name</th>
                      <th>Status</th>
                      <th style={{ whiteSpace: "nowrap" }}>Published By</th>
                      <th>Created At</th>
                      <th>Stop Time</th>
                      <th>Next Tick</th>
                      <th>Time Frequency</th>
                      <th colSpan={2} style={{ textAlign: "center" }}>
                        <button
                          style={{
                            backgroundColor: "#1d262e",
                            color: "#fff",
                            border: "none",
                            padding: "6px 12px",
                            fontSize: "12px",
                            borderRadius: "4px",
                            cursor: "pointer",
                          }}
                          onClick={() => exportToExcel(schedules)}
                        >
                          Export to Excel
                        </button>
                      </th>
                      {/* <th>Next Tick</th> */}
                      {/* <th></th> */}
                    </tr>
                  </thead>
                  <tbody className="table-body">
                    {mappedSchedules.map((obj, ind) => {
                      return (
                        <tr
                          key={ind}    
                        >
                          <td className="scheduleName"> 
                                {obj.name.length > 8 ? (
                                  <EllipsisWithTooltip>
                                    {obj.name}
                                  </EllipsisWithTooltip>
                                ) : (
                                  obj.name
                                )}
                          </td>
                          <td>
                            {obj.bot_id.length > 12 ? (
                              <EllipsisWithTooltip>
                                {obj.bot_id}
                              </EllipsisWithTooltip>
                            ) : (
                              <div>{obj.bot_id}</div>
                            )}
                          </td>

                          <td>
                            {obj.worker_name ? (
                              obj.worker_name.length > 10 ? (
                                <EllipsisWithTooltip>
                                  {obj.worker_name}
                                </EllipsisWithTooltip>
                              ) : (
                                <div>{obj.worker_name}</div>
                              )
                            ) : (
                              "-"
                            )}
                          </td>
                          <td>{obj.status}</td>

                          <td
                            className="email"
                            style={{ marginLeft: "3px !important" }}
                          >
                            {obj.email.length > 12 ? (
                              <EllipsisWithTooltip>
                                {obj.email}
                              </EllipsisWithTooltip>
                            ) : (
                              <div className="email">{obj.email}</div>
                            )}
                          </td>

                          <td>
                            <EllipsisWithTooltip>
                              {stringToDate(obj.created_at)}
                            </EllipsisWithTooltip>
                          </td>
                          <td>
                                {obj.stop_time.length === 16 ? (
                                  <EllipsisWithTooltip>
                                    {stringToDate(obj.stop_time)}
                                  </EllipsisWithTooltip>
                                ) : (
                                  "-"
                                )}
                          </td>

                          <td>
                            <EllipsisWithTooltip>
                              {stringToDate(obj.next_interval)}
                            </EllipsisWithTooltip>
                          </td>

                          <td>
                            <EllipsisWithTooltip>
                              {getCronDescription(obj.cron_expression)}
                            </EllipsisWithTooltip>
                          </td>
                          <td colSpan={2}>
                            <div className="td-btns">
                              <div className="view" onClick={() => setViewModalOpen(true)}>
                                <Tooltip placement="bottom" title="View"><EyeOutlined onClick={() => handleViewClick(obj)}/></Tooltip>
                              </div>
                              <div className="edit">
                                <Tooltip placement="bottom" title="Edit"><EditOutlined  onClick={() => handleEditClick(obj)}/></Tooltip>
                              </div>
                              <div className="delete">
                                <Tooltip placement="bottom" title="Delete"><DeleteOutlined style={{ color: "red" }} onClick={() => deleteModalToggle(obj)} /></Tooltip>
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            ) :
              schedules.length === 0 && search_data != null ? (
                <div className="content">
                  <Table hover responsive className="responsive-table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Bot Name</th>
                        <th style={{ whiteSpace: "nowrap" }}>Worker Name</th>
                        <th>Timezone</th>
                        <th>Status</th>
                        <th style={{ whiteSpace: "nowrap" }}>Published By</th>
                        <th>Created At</th>
                        <th>Stop Time</th>
                        <th>Next Tick</th>
                      </tr>
                    </thead>
                  </Table>
                </div>
              ) : (
                <div className="empty-skill text-center">
                  <img src={EmptyScreen} alt="empty Screen"></img>
                  <p>Seems like you don't have any schedules yet.</p>
                  <button
                    className="btn btn-primary"
                    onClick={handleCreateSchedule}
                  >
                    {createSchedule ? (
                      <div className="sp sp-circle text-white"></div>
                    ) : (
                      "+ Please create"
                    )}
                  </button>
                </div>
              )}

            {modal ? (
              <CustomModal
                comp={
                  <CreateSchedule
                    toggle={() => toggle()}
                    scheduleSuccess={() => scheduleSuccess()}
                    workers={workers}
                    bots={bots}
                    modal={modal}
                  />
                }
                name="New Schedule"
                toggle={() => toggle()}
                modal={modal}
              />
            ) : null}
            {deleteModal ? (
              <CustomModal
                comp={
                  <DeleteSchedule
                    handleDelete={() => handleDelete()}
                    toggle={() => deleteModalToggle()}
                    name={schedule.name}
                  />
                }
                name={`Are you sure you want to delete`}
                toggle={() => deleteModalToggle()}
                modal={deleteModal}
              />
            ) : null}
            {schedule_Success ? (
              <CustomModal
                comp={<ScheduleSuccess reload={() => reload()} />}
                name="Schedule Created"
                toggle={() => reload()}
                modal={schedule_Success}
              />
            ) : null}
            <Modal
              title="Schedule Data"
              centered
              open={viewModalOpen}
              footer={[
                <button
                  key="ok"
                  onClick={() => setViewModalOpen(false)}
                  style={{
                    backgroundColor: "#1d262e",
                    color: "#fff",
                    border: "none",
                    padding: "8px 16px",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  OK
                </button>,
              ]}
              onOk={() => setViewModalOpen(false)}
              onCancel={() => setViewModalOpen(false)}
            >
              {selectedSchedule ? (
                <div className="modal-table-view">
                  <div className="sch-item">
                    <div className="sch-item-title">Name</div>
                    <div className="sch-item-value">{selectedSchedule.name}</div>
                  </div>
                  <div className="sch-item">
                    <div className="sch-item-title">Bot ID</div>
                    <div className="sch-item-value">{selectedSchedule.bot_id}</div>
                  </div>
                  <div className="sch-item">
                    <div className="sch-item-title">Worker Name</div>
                    <div className="sch-item-value">
                      {selectedSchedule.worker_name || "-"}
                    </div>
                  </div>
                  <div className="sch-item">
                    <div className="sch-item-title">Status</div>
                    <div className="sch-item-value">{selectedSchedule.status}</div>
                  </div>
                  <div className="sch-item">
                    <div className="sch-item-title">Published By</div>
                    <div className="sch-item-value">{selectedSchedule.email}</div>
                  </div>
                  <div className="sch-item">
                    <div className="sch-item-title">Created At</div>
                    <div className="sch-item-value">
                      {stringToDate(selectedSchedule.created_at)}
                    </div>
                  </div>
                  <div className="sch-item">
                    <div className="sch-item-title">Stopped At</div>
                    <div className="sch-item-value">
                      {selectedSchedule.stop_time
                        ? stringToDate(selectedSchedule.stop_time)
                        : "-"}
                    </div>
                  </div>
                  <div className="sch-item">
                    <div className="sch-item-title">Next Tick</div>
                    <div className="sch-item-value">
                      {stringToDate(selectedSchedule.next_interval)}
                    </div>
                  </div>
                  <div className="sch-item">
                    <div className="sch-item-title">Time Frequency</div>
                    <div className="sch-item-value">
                      {getCronDescription(selectedSchedule.cron_expression)}
                    </div>
                  </div>
                </div>
              ) : (
                <p>No data available</p>
              )}
            </Modal>
            <Modal
              title="Edit Schedule"
              className="modal-default"
              centered
              open={editModalOpen}
              onCancel={() => setEditModalOpen(false)}
              footer={[
                <button
                  key="cancel"
                  onClick={() => setEditModalOpen(false)}
                  style={{
                    backgroundColor: "#f0f0f0",
                    color: "#000",
                    border: "none",
                    padding: "8px 16px",
                    borderRadius: "4px",
                    cursor: "pointer",
                    marginRight: "8px",
                  }}
                >
                  Cancel
                </button>,
                <button
                  key="save"
                  onClick={handleSaveChanges}
                  disabled={isLoading}
                  style={{
                    backgroundColor: "#1d262e",
                    color: "#fff",
                    border: "none",
                    padding: "8px 16px",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  {isLoading ? (
                  
                   <div class="sp sp-circle text-light"></div>
                  ) : (
                    "Save"
                  )}
                </button>,
              ]}
            >
              <div className="edit-modal-content">
               
                  <div className="ip-tl-label">
              <span className="tl-label" htmlFor="inputEmail4">
                Name
              </span>
              <input
                    type="text"
                    value={newName}
                    onChange={(e) => setNewName(e.target.value)}
                    placeholder="Enter new name"
                    className="form-control"
                  />
            </div>
             
                <div className="ip-tl-label">
              <span className="tl-label" htmlFor="inputEmail4">
                Stop Time
              </span>
              <input
                    type="datetime-local"
                    value={newStopTime}
                    onChange={(e) => setNewStopTime(e.target.value)}
                    className="form-control"
                  />
                </div>

                <div className="frm-block">
                  <div className="ip-tl-label">
                    <span className="tl-label" htmlFor="inputEmail4">
                      E-Worker
                    </span>
                    <select
                      value={obj.worker_id || ""}
                      onChange={(e) => {
                        setWorkerName(e.target.value);
                        setObj((prevObj) => ({
                          ...prevObj,
                          worker_id: e.target.value,
                        }));
                      }}
                      required
                      name="worker"
                    >
                      <option value="">Select Worker</option>
                      {sessionData.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.session_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="form-group">
                  <label>Time Frequency</label>
                  <h5>Trigger</h5>
                  <div className="trigger-buttons">
                    {["minutes", "hourly", "daily", "weekly", "monthly", "advanced"].map((value) => (
                      <button
                        key={value}
                        name="triggerType"
                        value={value}
                        className={obj.triggerType === value ? "active" : ""}
                        onClick={handleTriggerChange}
                        style={{
                          backgroundColor: obj.triggerType === value ? "#007bff" : "#f9f9f9",
                          color: obj.triggerType === value ? "#fff" : "#000",

                          cursor: "pointer",
                        }}
                      >
                        {value.charAt(0).toUpperCase() + value.slice(1)}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="frm-block">{renderTrigger()}</div>
              </div>
            </Modal>
          </div>
        </div>   
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps, { getWorkers, getProcesses, notify })(
  Schedules
);
